import React, { FC } from 'react'

import { Column } from '../column'

import { useStyle } from './content.styles'
import { ContentProps } from './content.types'

export const Content: FC<ContentProps> = ({
  className = '',
  preset = 'default',
  padding = '',
  justifyContent,
  alignItems,
  children
}) => {
  const classes = useStyle({ preset, padding })
  return (
    <Column
      fullWidth
      fullHeight
      alignItems={alignItems}
      className={`${className} ${classes.container}`}
      justifyContent={justifyContent}
    >
      {children}
    </Column>
  )
}
